import PropTypes from 'prop-types';
import React from 'react';

const VacationsPage = ({ less2, more1, twins, triplet }) => (
    <div className="page">
        <span> Congé maternité </span>
        <div>
            <span>1 enfant à charge </span>
            <span> {`Du ${less2.start} (35 SA)`} </span>
            <span> {`Au ${less2.end} (51 SA)`} </span>
        </div>
        <div>
            <span>2 + enfants à charge </span>
            <span> {`Du ${more1.start} (33 SA)`} </span>
            <span> {`Au ${more1.end} (59 SA)`} </span>
        </div>
        <div>
            <span>Jumeaux </span>
            <span> {`Du ${twins.start} (29 SA)`} </span>
            <span> {`Au ${twins.end} (63 SA)`} </span>
        </div>
        <div>
            <span>Triplés </span>
            <span> {`Du ${triplet.start} (17 SA)`} </span>
            <span> {`Au ${triplet.end} (63 SA)`} </span>
        </div>
    </div>
);
const startEndProp = PropTypes.shape({ start: PropTypes.string.isRequired, end: PropTypes.string.isRequired });
VacationsPage.propTypes = {
    less2: startEndProp.isRequired,
    more1: startEndProp.isRequired,
    twins: startEndProp.isRequired,
    triplet: startEndProp.isRequired,
};

export default VacationsPage;
